import React, { useState } from "react";
// react component for creating dynamic tables
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import { useHistory } from "react-router-dom";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import GetApp from "@material-ui/icons/GetApp";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import dateFormat from "dateformat";

// @material-ui/lab components
// @material-ui/icons components
// core components
import Snackbar from "components/Snackbar/Snackbar.js";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import btnComponentStyles from "assets/theme/components/button.js";
import LoadingAnimation from "components/Animations/loading";
import Slide from "@material-ui/core/Slide";
import { useAsyncEffect } from "use-async-effect";
import { redirectToLogout,numericSortFunc,dateSortFunc,zeroFill } from "common/SharedFn";
import { getUserReferralEntries } from "../../network/ApiAxios";
import { ArrowBack} from "@material-ui/icons";

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(btnComponentStyles);
const createHistory = require("history").createBrowserHistory;

const pagination = paginationFactory({
  page: 1,
  alwaysShowAllBtns: true,
  showTotal: true,
  withFirstAndLast: false,
  sizePerPageRenderer: ({ onSizePerPageChange }) => (
    <div className="dataTables_length" id="datatable-basic_length">
      <label>
        Show{" "}
        {
          <select
            name="datatable-basic_length"
            aria-controls="datatable-basic"
            className="form-control form-control-sm"
            onChange={(e) => onSizePerPageChange(e.target.value)}
          >
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        }{" "}
        entries.
      </label>
    </div>
  ),
});

const { SearchBar } = Search;

const { ExportCSVButton } = CSVExport;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
    
const UserReferralsTable = (props) => {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const [alert, setAlert] = React.useState(false);
  const componentRef = React.useRef(null);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [showError, setShowError] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [addModal, setAddModal] = useState(false);
  const [forceRefresh, setForceRefresh] = useState(false);
  var currentUserId = props.match.params.id;
  let history = useHistory();

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };

  const fetchEntries = async () => {
    setForceRefresh(false);
    setIsLoading(true);
    try{
    const response = await getUserReferralEntries(currentUserId);
    const { data } = response;
    if (data.result.isSuccess) {
      setData(data.data.map((prop) => makeTableRow(prop)));
      //setError("");
    } else {
      showErrorNotification(data.result.description);
      if(data.result.code == -2){
        redirectToLogout();
      }
    }
    }
    catch(ex){
      showErrorNotification("Failed to fetch entries");
    }
    setIsLoading(false);
  };


  useAsyncEffect(async () => {
    fetchEntries();

  }, [forceRefresh]);


  const makeTableRow = (info) => {
    info.onDateTimeText = dateFormat(
      new Date(info.onDatetime),
      "d-mmm-yyyy hh:MM TT"
    );
    info.newUserReceivedCreditsOnDatetimeText = dateFormat(
      new Date(info.newUserReceivedCreditsOnDatetime),
      "d-mmm-yyyy hh:MM TT"
    );
    info.referralUserReceivedCreditsOnDatetimeText = dateFormat(
      new Date(info.referralUserReceivedCreditsOnDatetime),
      "d-mmm-yyyy hh:MM TT"
    );
    info.newUserReceivedCreditsText = info.newUserReceivedCredits.toFixed(3);
    info.referralUserReceivedCreditsText = info.referralUserReceivedCredits.toFixed(3);
    return {
      ...info,
      idForm: (
        "R"+zeroFill(info.id,5)
      ),
      newUserIdForm: (
        "C"+zeroFill(info.newUserId,5)
      ),
      referralUserIdForm: (
        "C"+zeroFill(info.referralUserId,5)
      ),
      // actions: (
      // ),
    };
  };

  return (
    <>
      {alert}
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >

        <Grid container>
          <Grid item xs={12}>
            <Card elevation={0}>

              <div style={{width: "100%"}}>
              <ToolkitProvider
                data={data}
                keyField="id"
                columns={[
                  {
                    dataField: "idForm",
                    text: "ID",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "newUserIdForm",
                    text: "Referred User",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "newUserReceivedCreditsText",
                    text: "Referred User Credits Earned",
                    sort: true,
                    sortFunc: numericSortFunc,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "newUserReceivedCreditsOnDatetimeText",
                    text: "Referred User Received Credits on DateTime",
                    sort: true,
                    sortFunc: dateSortFunc,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "referralUserReceivedCreditsText",
                    text: "Credits Earned",
                    sort: true,
                    sortFunc: numericSortFunc,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "referralUserReceivedCreditsOnDatetimeText",
                    text: "Received Credits on DateTime",
                    sort: true,
                    sortFunc: dateSortFunc,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "onDateTimeText",
                    text: "On DateTime",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                ]}
                search
                exportCSV
              >
                {(props) => (
                                    <>
                  <CardHeader
                    style={{ paddingTop: "0.875rem", paddingBottom: "0.875rem" }}
                    title={
                      <>
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >
                      <Tooltip title="Back">
            <Button size="small" 
                  classes={{
                    root: classes.buttonContainedPrimary,
                  }} 
                  variant="contained" 
                  style={{ marginRight: "20px" }}
                  onClick={() => {
                    history.goBack();
            }}>
              <Box component={ArrowBack} />
            </Button>
          </Tooltip>
                      <Box component="span">User ID #{currentUserId} Referral Entries</Box>
                    </Box>
                      </>
                    }
                    action={
                      <Box
                        display="flex" alignItems="center" flexWrap="wrap"
                        justifyContent="flex-end"
                        style={{ gap: 8, marginTop: 8, marginRight: 8 }}
                      >
                        <div
                          id="datatable-basic_filter"
                          style={{ display: "flex", alignItems: "center", height: 40 }}
                        >
                          <SearchBar
                            className="form-control-sm"
                            placeholder="Search..."
                            style={{ height: 40, margin: 0, boxSizing: "border-box" }}
                            {...props.searchProps}
                          />
                        </div>
                        <Tooltip title="Download CSV">
                          <span style={{ display: "flex" }}>
                            <ExportCSVButton
                              className="MuiButtonBase-root"
                              style={{
                                width: 40, height: 40, padding: 0,
                                display: "flex", alignItems: "center", justifyContent: "center",
                                border: "1px solid #172b4d", borderRadius: 8,
                                color: "#fff", backgroundColor: "#172b4d", cursor: "pointer",
                              }}
                              {...props.csvProps}
                            >
                              <GetApp style={{ width: 18, height: 18 }} />
                            </ExportCSVButton>
                          </span>
                        </Tooltip>
                      </Box>
                    }
                  />
                  <div className="table-responsive">
                    <BootstrapTable
                      ref={componentRef}
                      {...props.baseProps}
                      bootstrap4={true}
                      pagination={pagination}
                      bordered={true}
                      striped={true}
                      //filter={ filterFactory() }
                      noDataIndication={() =>
                        isLoading ? (
                          <Box
                            component={Grid}
                            container
                            justifyContent="center"
                            className="justify-content-center"
                          >
                            <div
                              className="text-center"
                              style={{ width: "20%" }}
                            >
                              <LoadingAnimation />{" "}
                            </div>
                          </Box>
                        ) : (
                          <h4>No Records</h4>
                        )
                      }
                      id="main-table"
                    />
                    
                  </div>
                                      </>
                )}
              </ToolkitProvider>
              </div>
            </Card>
          </Grid>
        </Grid>
        <Snackbar
          place="tr"
          color="success"
          // icon={AddAlert}
          message={notifMessage}
          open={success}
          closeNotification={() => setSuccess(false)}
          close
        />

        <Snackbar
          place="tr"
          color="rose"
          // icon={AddAlert}
          message={notifMessage}
          open={showError}
          closeNotification={() => setShowError(false)}
          close
        />
      </Container>
    </>
  );
};

export default UserReferralsTable;
